'use client';

import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
import TitleBar from '../layout/TitleBar';
import { queryIaVendors, saveIaVendor, type IaVendor } from '@/hooks/useInventoryAuditorPurchasing';
import { useNotification } from '@/contexts/NotificationContext';

const InventoryAuditorVendorsPage: React.FC = () => {
  const { showSuccess, showError } = useNotification();
  const [rows, setRows] = useState<IaVendor[]>([]);
  const [name, setName] = useState('');
  const [code, setCode] = useState('');

  const load = useCallback(async () => {
    try {
      setRows(await queryIaVendors());
    } catch (e: unknown) {
      showError(e instanceof Error ? e.message : 'Failed to load vendors');
    }
  }, [showError]);

  useEffect(() => {
    void load();
  }, [load]);

  const handleCreate = async () => {
    if (!name.trim()) return;
    try {
      await saveIaVendor({ name: name.trim(), code: code.trim() || null });
      setName('');
      setCode('');
      showSuccess('Vendor saved');
      await load();
    } catch (e: unknown) {
      showError(e instanceof Error ? e.message : 'Failed to save vendor');
    }
  };

  return (
    <>
      <TitleBar breadcrumbs={[{ label: 'Home', href: '/app/dashboard' }, { label: 'Vendors' }]} title="Vendors" />
      <Box sx={{ p: 2 }}>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Add vendor
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <TextField size="small" label="Name" value={name} onChange={(e) => setName(e.target.value)} />
            <TextField size="small" label="Code" value={code} onChange={(e) => setCode(e.target.value)} />
            <Button variant="contained" onClick={() => void handleCreate()} sx={{ textTransform: 'none' }}>
              Save
            </Button>
          </Box>
        </Paper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Code</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((v) => (
              <TableRow key={v.id}>
                <TableCell>{v.name}</TableCell>
                <TableCell>{v.code ?? '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </>
  );
};

export default InventoryAuditorVendorsPage;
